/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Valideur d'un tunnel, tel qu'affiché dans la configuration de la validation.
 * @export
 * @interface TunnelValideurDto
 */
export interface TunnelValideurDto {
    /**
     * 
     * @type {string}
     * @memberof TunnelValideurDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TunnelValideurDto
     */
    abpUserId: string;
    /**
     * 
     * @type {string}
     * @memberof TunnelValideurDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TunnelValideurDto
     */
    email?: string | null;
    /**
     * Désignation du cabinet (personne morale) du valideur, null s'il n'en a pas.
     * @type {string}
     * @memberof TunnelValideurDto
     */
    cabinet?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TunnelValideurDto
     */
    plateformeId: string;
    /**
     * 
     * @type {string}
     * @memberof TunnelValideurDto
     */
    plateformeNom?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TunnelValideurDto
     */
    isPrincipal: boolean;
    /**
     * false quand le valideur ne porte plus la brique Valideur sur sa plateforme.
     * @type {boolean}
     * @memberof TunnelValideurDto
     */
    briqueActive: boolean;
    /**
     * Courtiers auxquels le valideur est restreint ; vide = tous les courtiers habilités.
     * @type {Array<string>}
     * @memberof TunnelValideurDto
     */
    courtierIds: Array<string>;
}

/**
 * Check if a given object implements the TunnelValideurDto interface.
 */
export function instanceOfTunnelValideurDto(value: object): value is TunnelValideurDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('abpUserId' in value) || value['abpUserId'] === undefined) return false;
    if (!('plateformeId' in value) || value['plateformeId'] === undefined) return false;
    if (!('isPrincipal' in value) || value['isPrincipal'] === undefined) return false;
    if (!('briqueActive' in value) || value['briqueActive'] === undefined) return false;
    if (!('courtierIds' in value) || value['courtierIds'] === undefined) return false;
    return true;
}

export function TunnelValideurDtoFromJSON(json: any): TunnelValideurDto {
    return TunnelValideurDtoFromJSONTyped(json, false);
}

export function TunnelValideurDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TunnelValideurDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'abpUserId': json['abpUserId'],
        'nom': json['nom'] == null ? undefined : json['nom'],
        'email': json['email'] == null ? undefined : json['email'],
        'cabinet': json['cabinet'] == null ? undefined : json['cabinet'],
        'plateformeId': json['plateformeId'],
        'plateformeNom': json['plateformeNom'] == null ? undefined : json['plateformeNom'],
        'isPrincipal': json['isPrincipal'],
        'briqueActive': json['briqueActive'],
        'courtierIds': json['courtierIds'],
    };
}

export function TunnelValideurDtoToJSON(json: any): TunnelValideurDto {
    return TunnelValideurDtoToJSONTyped(json, false);
}

export function TunnelValideurDtoToJSONTyped(value?: TunnelValideurDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'abpUserId': value['abpUserId'],
        'nom': value['nom'],
        'email': value['email'],
        'cabinet': value['cabinet'],
        'plateformeId': value['plateformeId'],
        'plateformeNom': value['plateformeNom'],
        'isPrincipal': value['isPrincipal'],
        'briqueActive': value['briqueActive'],
        'courtierIds': value['courtierIds'],
    };
}

